import React from "react";

const RegionalConnections = ({ data }) => {
    return (
        <div className="w-full mx-auto max-w-[80%] grid grid-cols-2 lg:grid-cols-1 xs:grid-cols-1 gap-12 items-center py-16 2xl:max-w-6xl">
            <div className="text-left pr-10 2xl:pr-24 xs:pr-0 xs:text-center">
                <h1 className="text-6xl text-[#444444] leading-tight w-[70%] pb-4 2xl:text-5xl xs:text-3xl xs:w-full">
                    {data.title}
                </h1>
                <p className="text-2xl text-[#767676] mt-4 w-[70%] 2xl:text-xl xs:w-full">
                    {data.subheading}
                </p>
            </div>

            <div className="grid grid-cols-[auto_1fr] items-center gap-10 xs:p-6">
                <div className="w-[3px] h-full bg-[#EC0000] xs:hidden"></div>

                <div className="grid grid-rows-2 grid-cols-2 gap-6 pl-14 2xl:pl-4 xs:pl-14">
                    {data.statistics.map((stat, index) => (
                        <div key={index} className="flex flex-col">
                            <span className="text-6xl text-[#EC0000] pb-4 2xl:text-4xl xs:text-3xl">
                                {stat.text}
                            </span>
                            <span className="text-lg text-[#767676]">
                                {stat.textTwo}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RegionalConnections;
